import { ReplaceKomaModel } from '../vo/replace-koma.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * コマ入替コマンド
 *
 * @export
 * @class ReplaceKomaService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class ReplaceKomaService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private vo: ReplaceKomaModel = null;
  private successFunction: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessResult} リクエストJSON
   * @memberof ReplaceKomaService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      update: {
        Koma: {
          parameter: {
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            KomaIDFr: this.vo.komaIDFr,
            KomaIDTo: this.vo.komaIDTo,
            PageNumFr: this.vo.pageNumFr,
            PageNumTo: this.vo.pageNumTo,
            PublishAmountFr: this.vo.publishAmountFr,
            PublishAmountTo: this.vo.publishAmountTo
          }
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {ReplaceKomaModel} vo パラメータ
   * @param {Function} successFunction 成功時後続処理
   * @memberof ReplaceKomaService
   */
  execute(vo: ReplaceKomaModel, successFunction: Function) {
    this.vo = vo;
    this.successFunction = successFunction;
    this.send('KYMW14replaceKoma', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof ReplaceKomaService
   */
  success(_: any) {
    this.successFunction();
  }
}
